// TODO: @danealton отрефакторить метод, сделать проверки допустов дат через timestamp
import dateValidation from 'lib/identity/validation/date';

// eslint-disable-next-line no-useless-escape
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// eslint-disable-next-line no-useless-escape
const PHONE_REGEX = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

function isEmail(value) {
  return EMAIL_REGEX.test(value);
}

function isPhone(value) {
  return PHONE_REGEX.test(value);
}

// eslint-disable-next-line complexity
const getError = (value, { email, phone, required, min, max, date, passport }) => {
  if (email) {
    if (!required && value.length === 0) {
      return false;
    }

    return !isEmail(value);
  }

  if (phone) {
    if (!required && value.length === 0) {
      return false;
    }

    return !isPhone(value);
  }

  if (date) {
    if (!required && value.length === 0) {
      return false;
    }

    return !dateValidation(value, date);
  }

  if (passport) {
    if (!required && value.length === 0) {
      return false;
    }

    return !passport.validation.test(value);
  }

  if (min || max) {
    if (!required && value.length === 0) {
      return false;
    }

    return value.length <= min || value.length >= max;
  }

  if (required) {
    return !value;
  }

  return false;
};

export default getError;
